var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('th',[_vm._v("Tsttest")]),_c('th',[_vm._v("Tstdate")]),_c('th',[_vm._v("Tstsize")]),_c('th',[_vm._v("Tstres")])])}
var staticRenderFns = []

export { render, staticRenderFns }